
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you use results obtained with Nextclade in a publication, please`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`cite our paper:`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote">{`Aksamentov, I., Roemer, C., Hodcroft, E. B., & Neher, R. A., (2021). Nextclade: clade assignment, mutation calling and quality control for viral genomes. Journal of Open Source Software, 6(67), 3773, `}<a parentName="p" {...{
              "href": "https://doi.org/10.21105/joss.03773"
            }}>{`https://doi.org/10.21105/joss.03773`}</a></p>
        </blockquote>
        <p parentName="li">{`(`}<a parentName="p" {...{
            "href": "/citation.bib"
          }}>{`bibtex`}</a>{`)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`where possible, provide a link to Nextclade Web:`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote"><a parentName="p" {...{
              "href": "https://clades.nextstrain.org"
            }}>{`https://clades.nextstrain.org`}</a></p>
        </blockquote>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;